import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logTripPlannerCTAViewedParams = {
  entry_point?: CardLocation;
  location_id?: number;
  park_id?: number;
};

/**
 * Trip Planner entry CTA is shown to the user on web (explore, park page, or location page).
 * @param params - Attributes to log with the amplitude event
 * @param params.entry_point - Surface where the Trip Planner CTA was shown.
 * @param params.location_id - Id of the location associated with the page where the CTA was shown, if applicable.
 * @param params.park_id - Id of the park associated with the page where the CTA was shown, if applicable.
 */
const logTripPlannerCTAViewed = ({ entry_point, location_id, park_id }: logTripPlannerCTAViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'trip planner cta viewed',
    { 'entry point': entry_point, 'location id': location_id, 'park id': park_id },
    callback
  );
};

export default logTripPlannerCTAViewed;
